import { ControlType, Field, Section } from "@cotecna/dynamic-view-engine";

const RE_ASSIGN_INSPECTION_FIELDS: Field[] = [
  {
    id: "assignedInspector",
    type: ControlType.Dropdown,
    label: "Assigned Inspector",
    order: 1,
    propertyName: "assignedInspector",
    value: "",
    required: true,
    visible: true,
    valid: false,
    readOnly: false,
  },
  {
    id: "comments",
    type: ControlType.TextArea,
    label: "Comments / Remarks",
    order: 2,
    propertyName: "comments",
    value: "",
    required: true,
    visible: true,
    valid: false,
    readOnly: false,
  },
];

export const RE_ASSIGN_INSPECTION_FORM: Section[] = [
  {
    id: "1",
    name: "",
    isFixed: true,
    order: 1,
    fields: RE_ASSIGN_INSPECTION_FIELDS,
    actions: [],
  },
];

export const RE_ASSIGN_INSPECTION_CONTROLS: any[] = [
  {
    id: "assignedInspector",
    options: [],
  },
  {
    id: "comments",
    maxLength: 1500,
  },
];
